// extracted by extract-css-chunks-webpack-plugin
module.exports = {"info":"info-3cGwXx0i","hardAd":"hardAd-3wpsEeoh"};